import React, { useState, useCallback } from 'react';
import classNames from 'classnames';
import styles from './fix-image.module.scss';
import FixImagePlaceholder from './fix-image-placeholder';
import { useLayoutType, LayoutStyleTypes, LayoutTypes } from "@/util-react/layout";

export interface FixImageProps {
  src?: string;
  alt?: string;
  type?: LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM;
  className?: string;
  aspect?: number;
}

export const FixImage: React.FC<FixImageProps> = ({
  src,
  alt = '',
  type = LayoutStyleTypes.TYPE_LG,
  className,
  aspect = 1,
}) => {
  const [content, setContent] = useState(false);

  const handleLoad = useCallback(() => {
    setContent(true);
  }, []);

  let img;

  if (typeof Image === "undefined") {
    img = { src: src ?? "" };
  } else {
    img = new Image();
    img.src = src ?? "";
    img.onload = handleLoad;
  }

  return (
    <div className={classNames(styles.root, styles.container, className)} style={{ "--size": undefined, "--aspect": aspect } as React.CSSProperties}>
      {src && <img className={classNames(styles.image, { [styles.visible]: content })} src={img.src} alt={alt} />}
      {!content && <FixImagePlaceholder type={type} className={styles.placeholder} />}
    </div>
  );
};

export default FixImage;
